<div class="organizer-wrapper">
  <div class="container">
    <header>
      <app-selector></app-selector>
    </header>

    <main>
      <app-calendar></app-calendar>
    </main>

    <div>
      <app-organizzzer></app-organizzzer>
    </div>
  </div>
</div>
